require('./bootstrap');
require('./components/loading-screen')
// require('./components/solution')
require('./components/video')
// require('./components/sliding')
require('./components/scroll')
// require('./components/map')
require('./components/cookie')
